export class Permission {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "permissionType",
            "baseName": "permissionType",
            "type": "PermissionType",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "allowConditions",
            "baseName": "allowConditions",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "category",
            "baseName": "category",
            "type": "PermissionCategory",
            "format": ""
        },
        {
            "name": "providerCategories",
            "baseName": "providerCategories",
            "type": "Array<PermissionProviderCategory>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Permission.attributeTypeMap;
    }
    constructor() {
    }
}
